import React from "react";

const ConnectedDevices = ({
  device,
  connectionDetail,
  selectedConnector,
  updateConnectorsListWithDevices,
  adapters_list,
  adapter,
}) => {
  const getAdapter = (adapter_id) => {
    return adapters_list.find((adapter_item) => adapter_item.id === adapter_id);
  };

  return (
    <div className="device-connected-item" key={device.id}>
      {/* <h3 className="text-center">{device.name}</h3> */}
      <div className="card">
        <div className="card-header text-center py-1 px-3">
          <span className="float-start">Device connected:</span>
          <h4 className="m-0 py-0">{device.name}</h4>
        </div>
        <div className="card-body py-0">
          <div className="row">
            <div className="col-6 col-sm-6 col-md-4 p-0 border-end">
              <img
                className="device-image"
                src={
                  `${process.env.PUBLIC_URL}/` +
                  "images/devices/" +
                  device.img_name
                }
              />
            </div>
            <div className="col-12 col-sm-6 col-md-8 p-0">
              <div className="device-connected-card">
                <div className="card-header">
                  <ul
                    class="nav nav-tabs card-header-tabs"
                    id="deviceTab"
                    role="tablist"
                  >
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="connection-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#connection"
                        role="tab"
                        aria-controls="connection"
                        aria-selected="true"
                      >
                        Connection
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="code-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#code"
                        role="tab"
                        aria-controls="code"
                        aria-selected="false"
                      >
                        Code snippet
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  <div className="tab-content" id="deviceTabContent">
                    <div
                      className="tab-pane show active device-connected-connection"
                      id="connection"
                      role="tabpanel"
                      aria-labelledby="connection-tab"
                    >
                      <table className="text-center table connection-table table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Device</th>
                            <th scope="col">Kurt board</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{device.pinout.supply}</td>
                            <td>{connectionDetail.board_pins.supply}</td>
                          </tr>
                          <tr>
                            <td>{device.pinout.ground}</td>
                            <td>{connectionDetail.board_pins.ground}</td>
                          </tr>

                          {device.pinout.signals.map((signal, index) => (
                            <tr>
                              <td>{signal}</td>
                              <td>
                                {connectionDetail.board_pins.signals[index]}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {getAdapter(device.adapter_id) ? (
                        <div className="mb-3">
                          Adapter: <b>{getAdapter(device.adapter_id).name}</b> -
                          {" Port: "}
                          <b>{device.adapter_port}</b>
                          <br />
                          <img
                            className="mt-1"
                            src={`${process.env.PUBLIC_URL}/images/devices/${
                              getAdapter(device.adapter_id).img_name
                            }`}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div
                      className="tab-pane device-connected-code"
                      id="code"
                      role="tabpanel"
                      aria-labelledby="code-tab"
                    >
                      This code is for EspHome:
                      <pre>
                        <code>{connectionDetail.code_snippet}</code>
                      </pre>
                    </div>
                  </div>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      className="btn btn-danger"
                      onClick={() =>
                        updateConnectorsListWithDevices([], selectedConnector)
                      }
                    >
                      Disconnect
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectedDevices;
